import { handleTextAndLinkType } from "domain/public/Landing/utils/content";
import { Spacing, spacing } from "globalStyles";
import { LinkType } from "interfaces/content";
import React from "react";
import styled from "styled-components";
import FlexBox from "ui/FlexBox";
import Body from "ui/Text/Body";
import { TextColor } from "ui/Text/helper";

export type Detail = Array<{
  label: string;
  value: string | LinkType | Array<string | LinkType>;
  supportText?: string;
}>;

interface Props {
  details: Detail;
  labelColumnWidth?: number;
  title?: string;
  color?: TextColor;
  verticalGap?: Spacing;
  className?: string;
}

const InlineDetails: React.FC<Props> = ({
  details,
  labelColumnWidth = 85,
  title,
  color = "secondary",
  verticalGap = spacing.extraSmall,
  className,
}) => {
  return (
    <FlexBox
      className={`${className} inline-details`}
      flexDirection="column"
      justify="flexStart"
    >
      {title && (
        <Body className="mb-sm" color={color} variant="body5">
          {title}
        </Body>
      )}
      <div>
        {details.map((detail) => {
          return (
            <Line verticalGap={verticalGap} key={detail.label}>
              {detail.label && (
                <LabelContainer width={labelColumnWidth}>
                  <Body variant="body7" color={color}>
                    {detail.label}:
                  </Body>
                </LabelContainer>
              )}
              <Body variant="body5" color={color} className="value">
                <FlexBox gap="4px" justify="flexStart">
                  {Array.isArray(detail.value)
                    ? detail.value.map((item, id) => (
                        <React.Fragment key={id}>
                          {handleTextAndLinkType(item)}
                          {id < (detail.value as Array<string | LinkType>).length - 1 &&
                            " ou "}
                        </React.Fragment>
                      ))
                    : handleTextAndLinkType(detail.value)}
                  {detail.supportText && "*"}
                </FlexBox>
                {detail.supportText && (
                  <Body variant="body9" color="secondary" className="support-text">
                    {detail.supportText}
                  </Body>
                )}
              </Body>
            </Line>
          );
        })}
      </div>
    </FlexBox>
  );
};

export default InlineDetails;

const Line = styled.div<{ verticalGap: Spacing }>`
  display: flex;
  justify-content: flex-start;
  white-space: pre-line;

  &:not(:first-of-type) {
    padding-top: ${({ verticalGap }) => verticalGap}px;
  }

  & .value {
    display: flex;
    flex-direction: column;
    gap: ${spacing.extraSmall}px;

    & .support-text {
      max-width: 300px;
    }
  }
`;

const LabelContainer = styled.div<{ width: number }>`
  width: ${({ width }) => width}px;
`;
